// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"55316f20","270":"357b0df2","453":"11986714","455":"01f3b508","704":"4f8d237d","977":"3e2ed683"}[chunkId] + ".chunk.js";
};